import ky from 'ky';
import toast from 'react-hot-toast';

import { refreshToken } from '@/features/auth/services/auth';
import {
  clearLocalStorageUser,
  getAccessToken,
  getLocalStorageUser,
  getRefreshToken,
  updateLocalStorageUser,
} from '@/utils/tokens';

const httpClient = ky.create({
  prefixUrl: import.meta.env.VITE_API_BASE_URL,
  retry: { limit: 0 },
  timeout: 60000,
});

export const apiClient = () => {
  const user = getLocalStorageUser();

  return httpClient.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set('Authorization', getAccessToken(user));
        },
      ],
      afterResponse: [
        async (request, _, response) => {
          if (response.status === 401) {
            refreshToken({ refresh_token: getRefreshToken(user) })
              .then((newUser) => {
                updateLocalStorageUser({ ...user, ...newUser });
                request.headers.set('Authorization', getAccessToken(newUser));
                return httpClient(request);
              })
              .catch(() => {
                clearLocalStorageUser();
                toast.error('session has expired please log in again');
                window.location.reload();
              });
          }
        },
      ],
    },
  });
};

export default httpClient;
